import { MemCommonMentionKind } from "@mem-labs/common-editor";
import { MDSDropdownItem } from "../dropdown-list-item";
import { StyledSelectionHeader } from "./dropdown-list-header.style";

type Props = {
  item: MDSDropdownItem | undefined;
};

export const MDSDropdownListHeader = ({ item }: Props) => {
  if (!item || !item.kind) return null;

  if (item.kind === MemCommonMentionKind.Note) {
    return <StyledSelectionHeader>Mention a note</StyledSelectionHeader>;
  }

  if (item.kind === MemCommonMentionKind.Collection) {
    return <StyledSelectionHeader>Mention a collection</StyledSelectionHeader>;
  }

  return null;
};
